export default __webpack_public_path__ + "static/media/image.vital-masks-pvt-ltd.03b25175.png";